import { render, staticRenderFns } from "./CookieModal.vue?vue&type=template&id=44ca5ed7&"
import script from "./CookieModal.vue?vue&type=script&lang=ts&"
export * from "./CookieModal.vue?vue&type=script&lang=ts&"
import style0 from "./CookieModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports